export default __webpack_public_path__ + "static/media/cpv_72_IT-service.8b3d1aee.svg";